var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: _vm.hh + 'px'})},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0"},attrs:{"src":_vm.url,"frameborder":"0","title":"企业数据统计分析"}})])}
var staticRenderFns = []

export { render, staticRenderFns }